import { api } from "./customers";

export const PatientListApi = api.injectEndpoints({
  endpoints: (build) => ({
    // Get Patient List
    getPatientList: build.query<any, { pageNo: number; name: any }>({
      query: ({ pageNo, name }) => `patient?page=${pageNo}&search=${name}`,
    }),

    // Get Prescription List
    getPrescriptionList: build.query<
      any,
      { pageNo: number; size?: number; Id: string }
    >({
      query: ({ pageNo, size = 10, Id }) =>
        `prescription_history?customerId=${Id}&page=${pageNo}&size=${size}`,
    }),

    // Get Appointment History
    getAppointmentHistory: build.query<any, { Id: string }>({
      query: ({ Id }) => `appointment_history?customerId=${Id}`,
    }),

    // Get Progress Notes History
    getProgressNotesHistory: build.query<any, { Id: string; pageNo: number }>({
      query: ({ Id, pageNo }) =>
        `progress_notes_history?customerId=${Id}&page=${pageNo}`,
    }),

    // Get Special Notes History
    getSpecialNotesHistory: build.query<
      any,
      { Id: string; pageNo: number; size?: number }
    >({
      query: ({ Id, pageNo, size = 10 }) =>
        `special_notes_history?customerId=${Id}&page=${pageNo}&size=${size}`,
    }),

    createProgressNotesHistory: build.mutation<any, any>({
      query: (formData) => ({
        url: `progress_notes_history`,
        method: "POST",
        body: formData,
      }),
    }),

    // Get Reports History
    getReportsHistory: build.query<any, { Id: string; pageNo: number }>({
      query: ({ Id, pageNo }) => `test_report?customerId=${Id}&page=${pageNo}`,
    }),

    // add report
    createReport: build.mutation<any, any>({
      query: (data) => ({
        url: `test_report`,
        method: "POST",
        body: data,
      }),
    }),

    //  Create Treatment
    createTreatment: build.mutation<any, any>({
      query: (data) => ({
        url: `treatment-history`,
        method: "POST",
        body: data,
        headers: {
          "Content-Type": "application/json",
        },
      }),
    }),

    //  Create Treatment
    AddNewInvoice: build.mutation<any, any>({
      query: (data) => ({
        url: `new_treatment_billing`,
        method: "POST",
        body: data,
        headers: {
          "Content-Type": "application/json",
        },
      }),
    }),

    //  Add Payment
    AddNewPayment: build.mutation<any, any>({
      query: (data) => ({
        url: `payment`,
        method: "POST",
        body: data,
        headers: {
          "Content-Type": "application/json",
        },
      }),
    }),

    // Get Procedure List
    getProcedures: build.query<any, void>({
      query: () => `procedure-template-list`,
    }),

    // Get Advice List
    getAdvice: build.query<any, void>({
      query: () => `advice_list`,
    }),

    // Get HE List
    getHEList: build.query<any, void>({
      query: () => `hematosylin_list`,
    }),

    // Get Complaints List
    getComplaintsList: build.query<any, void>({
      query: () => `complaints_list`,
    }),

    // Get Procedure List
    getProcedureTemplateList: build.query<any, void>({
      query: () => `procedure-template-list`,
    }),

    // Get Prescription history
    getPrescriptionHistory: build.query<any, string>({
      query: (customerId) => `prescription_history?customerId=${customerId}`,
    }),

    addNewTreatmentHistory: build.mutation<any, Partial<any>>({
      query: (body: any) => ({
        url: `new_treatment-history`,
        method: "POST",
        body,
      }),
      transformResponse: (response: { data: any }, meta, arg) => response.data,
    }),

    // Get Treatment History
    getTreatmentHistory: build.query<any, { Id: string; pageNo: number }>({
      query: ({ Id, pageNo }) =>
        `treatment_history?customerId=${Id}&page=${pageNo}`,
    }),

    createPregnancy: build.mutation<any, any>({
      query: (data) => ({
        url: `pregnacy_history`,
        method: "POST",
        body: data,
        headers: {
          "Content-Type": "application/json",
        },
      }),
    }),

    // Get Pregnancy History
    getPregnancyHistory: build.query<any, { Id: string; pageNo: number }>({
      query: ({ Id, pageNo }) =>
        `pregnacy_history?customerId=${Id}&page=${pageNo}`,
    }),

    // Get Customer Details by Customer ID
    getCustomerHistory: build.query<any, { Id: string }>({
      query: ({ Id }) => `customer/${Id}`,
    }),

    // Get Medical Details by Customer ID
    getMedicalDetailsByCustomerId: build.query<any, { customerId: string }>({
      query: ({ customerId }) =>
        `get_medical_detailsBycustomerID/${customerId}`,
    }),

    // Get Customer Contact by Customer ID
    getCustomerContactByCustomerId: build.query<any, { customerId: string }>({
      query: ({ customerId }) =>
        `get_customercontactBycustomerID/${customerId}`,
    }),

    // Get a specific report by report ID
    getReportById: build.query<any, { reportId: string }>({
      query: ({ reportId }) => `test_report/${reportId}`,
    }),
    getPatientCarePackages: build.query<any, { Id: any }>({
      query: ({ Id }) => `assignment_history_Details/${Id}`,
    }),

    addPrescriptions: build.mutation<any, Partial<any>>({
      query: (body: any) => ({
        url: `prescription`,
        method: "POST",
        body,
      }),
      transformResponse: (response: { data: any }, meta, arg) => response.data,
    }),

    updateNewPrescription: build.mutation<any, { id: string; data: any }>({
      query: ({ id, data }) => ({
        url: `prescription/${id}`,
        method: "PUT",
        body: data,
      }),
    }),

    updateAppointmentChangeStatus: build.mutation<any, { id: string; data: any }>({
      query: ({ id, data }) => ({
        url: `appointment_changes_status/${id}`,
        method: "PUT",
        body: data,
      }),
    }),

    addPatientCarePackages: build.mutation<any, Partial<any>>({
      query: (body: any) => ({
        url: `assignment_history`,
        method: "POST",
        body,
      }),
      transformResponse: (response: { data: any }, meta, arg) => response.data,
    }),
    updateCarePackageStatus: build.mutation<
      void,
      Pick<any, "id"> & Partial<any>
    >({
      query: ({ id, ...patch }) => ({
        url: `assignment_history_status/${id}`,
        method: "PUT",
        body: patch,
      }),
    }),
    getPatientInvoice: build.query<any, { Id: any }>({
      query: ({ Id }) => `customerinvoice?customerId=${Id}`,
    }),
  }),
});

export const {
  useGetPatientListQuery,
  useGetPrescriptionListQuery,
  useGetAppointmentHistoryQuery,
  useGetProgressNotesHistoryQuery,
  useGetSpecialNotesHistoryQuery,
  useCreateProgressNotesHistoryMutation,
  useGetReportsHistoryQuery,
  useCreateReportMutation,
  useGetTreatmentHistoryQuery,
  useGetPregnancyHistoryQuery,
  useGetCustomerHistoryQuery,
  useGetMedicalDetailsByCustomerIdQuery,
  useGetCustomerContactByCustomerIdQuery,
  useGetReportByIdQuery,
  useGetPatientCarePackagesQuery,
  useAddPatientCarePackagesMutation,
  useUpdateCarePackageStatusMutation,
  useGetPatientInvoiceQuery,
  useCreateTreatmentMutation,
  useGetProceduresQuery,
  useGetAdviceQuery,
  useGetHEListQuery,
  useGetPrescriptionHistoryQuery,
  useCreatePregnancyMutation,
  useGetComplaintsListQuery,
  useGetProcedureTemplateListQuery,
  useAddPrescriptionsMutation,
  useUpdateNewPrescriptionMutation,
  useAddNewTreatmentHistoryMutation,
  useUpdateAppointmentChangeStatusMutation,
  useAddNewInvoiceMutation,
  useAddNewPaymentMutation,
} = PatientListApi;
